var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-quote-radio-buttons",class:{
        'rounded-small': _vm.roundedSmall,
        fixed: _vm.fixed,
        'fixed-mobile': _vm.fixedMobile,
        'break-mobile': _vm.breakMobile,
        circle: _vm.circle
    }},[_c('div',{staticClass:"radio-buttons-wrap"},_vm._l((_vm.items),function(item){return _c('label',{key:item.value,class:{
                checked: _vm.newValue === item.value,
                'rounded-small': _vm.roundedSmall,
                fixed: _vm.fixed,
                'fixed-mobile': _vm.fixedMobile,
                circle: _vm.circle
            }},[(item.icon)?[(item.icon_amount)?[(item.value === 'any')?_c('span',[_c('span',{staticClass:"svg-icon"},[_vm._v(" + ")])]):_vm._e(),_vm._v(" "),_vm._l((item.icon_amount),function(i){return _c('span',{key:i,staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(
                            _vm.$icon(
                                _vm.newValue === item.value
                                    ? item.icon_checked
                                    : item.icon
                            )
                        )}})})]:(item.value === 'any')?[_c('span',{staticClass:"svg-icon"},[_vm._v("+")]),_vm._v(" "),_vm._l((2),function(i){return _c('span',{key:i,staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(_vm.$icon(_vm.icon))}})})]:[_c('span',{staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(
                            _vm.$icon(
                                _vm.newValue === item.value
                                    ? item.icon_checked
                                    : item.icon
                            )
                        )}})]]:_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],attrs:{"type":"radio"},domProps:{"value":item.value,"checked":_vm._q(_vm.newValue,item.value)},on:{"change":[function($event){_vm.newValue=item.value},_vm.onInput]}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.label))])],2)}),0),_vm._v(" "),(_vm.message)?_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }